/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Page_Share_BodyInputs */

const en_start_page_share_body = /** @type {(inputs: Start_Page_Share_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put it in your bio or send it to your clients. They pick a time on their own, and you stop answering "anything free on Thursday?".`)
};

const pl_start_page_share_body = /** @type {(inputs: Start_Page_Share_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wklej go w bio albo wyślij podopiecznym. Wybierają godzinę sami, a Ty nie odpisujesz na „masz coś w czwartek?”.`)
};

/**
* | output |
* | --- |
* | "Put it in your bio or send it to your clients. They pick a time on their own, and you stop answering \"anything free on Thursday?\"." |
*
* @param {Start_Page_Share_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const start_page_share_body = /** @type {((inputs?: Start_Page_Share_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Page_Share_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_start_page_share_body(inputs)
	return en_start_page_share_body(inputs)
});